import React, { SFC } from 'react';
import style from './LoadingProduct.module.scss';
import cn from 'classnames';

const LoadingProduct: SFC = () => <div className={cn('card', style.container)} />;

export default LoadingProduct;
